<template>
  <div id="trackinfo">
    <div class="group-add" style="margin: 0px">
      <h2 class="group-title"><slot name="uninclude-title">UnInclude</slot></h2>
      <h2 class="group-title"><slot name="include-title">Include</slot></h2>
    </div>
    <div class="group-add">
      <div class="group-container">
        <slot name="include-header" />
        <slot name="uninclude-header" />
      </div>
    </div>
    <div class="group-add">
      <div class="group-container">
        <div v-if="unInclude && unInclude.length > 0" class="group-list">
          <div
            v-for="(item, index) in unInclude"
            :key="item.id"
            :class="{ 'even-background': index % 2 === 0 }"
          >
            <slot
              name="uninclude-item"
              :item="item"
              :index="index"
              @remove-item="removeItem"
            />
          </div>
        </div>
        <div v-else class="no-items">{{ $t('noData') }}</div>
      </div>
      <div class="group-container">
        <div v-if="include && include.length > 0" class="group-list">
          <div
            v-for="(item, index) in include"
            :key="item.id"
            :class="{ 'even-background': index % 2 === 0 }"
          >
            <slot name="include-item" :item="item" :index="index" />
          </div>
        </div>
        <div v-else class="no-items">{{ $t('noData') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import { fetchData } from '../utils/api';

export default {
  name: 'GenericGroup',
  props: {
    apiEndpoint: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const include = ref([]);
    const unInclude = ref([]);
    const apiBaseUrl = inject('apiBaseUrl');
    const route = useRoute();
    const { t } = useI18n();
    const id = ref(0);

    onMounted(async () => {
      id.value = route.params.id;
      fetchData(t, `${apiBaseUrl}/group/${props.apiEndpoint}`, id.value).then((response) => {
        include.value = response.data.result.include;
        unInclude.value = response.data.result.not_include;
      });
    });
    return {
      t,
      id,
      include,
      unInclude,
    };
  },
  methods: {
    removeGroup(itemToRemove) {
      const index = this.include.indexOf(itemToRemove);
      if (index > -1) {
        this.include.splice(index, 1);
        this.unInclude.push(itemToRemove);
        this.include.sort((a, b) => a.id - b.id);
        this.unInclude.sort((a, b) => a.id - b.id);
      }
    },
    addGroup(itemToAdd) {
      const index = this.unInclude.indexOf(itemToAdd);
      if (index > -1) {
        this.unInclude.splice(index, 1);
        this.include.push(itemToAdd);
        this.include.sort((a, b) => a.id - b.id);
        this.unInclude.sort((a, b) => a.id - b.id);
      }
    },
  },
};
</script>

<style>
.group-add {
  display: flex;
  align-items: top;
  margin: 0px;
  padding: 0px;
  justify-content: space-between;
}
.group-container {
  flex: 1;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
}
.group-title {
  flex: 1;
}
.group-list {
  margin-right: 10px;
}
</style>
